import type { IGenericError } from '@allesauto/core/genericError';
import translate from '@allesauto/i18n';
import { Routes_DE as Routes } from '@allesauto/utils/routes';
import { ArrowRight16 } from '@carbon/icons-react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import * as React from 'react';
import { useIntl } from 'react-intl';

import SeoContainer from '@/global/containers/SeoContainer';

// workaround import path due to webpack bug https://github.com/webpack/webpack/issues/13865
const GenericError = dynamic<IGenericError>(
  () => import('../../../../packages/allesauto-core/src/lib/genericError')
);

export default function NotFoundPage() {
  const intl = useIntl();
  const router = useRouter();

  return (
    <>
      <SeoContainer
        pageHeadline={false}
        title={translate(intl, 'ui.NOT_FOUND.TEMPLATE_TITLE')}
      />
      <GenericError
        heading={translate(intl, 'ui.NOT_FOUND.HEADLINE')}
        description={translate(intl, 'ui.NOT_FOUND.DESCRIPTION')}
        ctaText={translate(intl, 'ui.NOT_FOUND.HOME_LINK')}
        onClick={() => router.push(Routes.ROOT)}
        icon={
          <ArrowRight16
            className="-mt-[1px] fill-purple80 h-5 w-5 monochrome:fill-black"
            aria-hidden="true"
          />
        }
      />
    </>
  );
}
